"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "createClient", {
    enumerable: true,
    get: function() {
        return createClient;
    }
});
const _connect = require("@connectrpc/connect");
const _connectnode = require("@connectrpc/connect-node");
const _lage_connect = require("./gen/lage/v1/lage_connect.js");
function createClient({ baseUrl, httpVersion }) {
    const transport = (0, _connectnode.createGrpcTransport)({
        httpVersion,
        baseUrl
    });
    return (0, _connect.createPromiseClient)(_lage_connect.LageService, transport);
}
